// SolarNova - Mock Data (Updated from Company Profile PDF)

export const LOGO_URL = "https://customer-assets.emergentagent.com/job_renewable-sa/artifacts/liizzat5_WhatsApp%20Image%202026-02-16%20at%206.45.35%20PM%20logo1.jpeg";

export const COMPANY = {
  name: "SolarNova",
  nameAr: "سولارنوفا",
  fullName: "Saudi German Factory for Solar Products (SGFS)",
  fullNameAr: "المصنع السعودي الالماني لمنتجات الطاقة الشمسية",
  tagline: "The Saudi Solar Factory",
  taglineAr: "المصنع السعودي للطاقة الشمسية",
  slogan: "Powering the Kingdom's Future",
  sloganAr: "نُنير مستقبل المملكة",
  subSlogan: "German Heritage. Saudi Manufacturing. Desert-Proven Quality.",
  heroTagline: "Meeting a great ambition — a dream coming true",
  location: "Building 4237, OAAB 4237, Al Kharj Industrial City, Al Kharj 16417, Kingdom of Saudi Arabia",
  locationAr: "مبنى ٤٢٣٧، المدينة الصناعية بالخرج، الخرج ١٦٤١٧، المملكة العربية السعودية",
  nationalAddress: {
    building: "4237",
    street: "OAAB 4237",
    secondary: "7630",
    district: "Al Kharj Industrial City",
    districtAr: "المدينة الصناعية بالخرج",
    postalCode: "16417",
    city: "Al Kharj",
    cityAr: "الخرج",
    country: "Kingdom of Saudi Arabia",
    countryAr: "المملكة العربية السعودية",
  },
  email: "info@sgfs.com.sa",
  website: "www.sgfs.com.sa",
  hours: "Mon–Sat, 09:00 AM to 6:00 PM",
  phone: "+966580167000",
  social: {
    twitter: "https://x.com/solarnova_sa",
    tiktok: "https://www.tiktok.com/@saudi.solarnova",
    linkedin: "https://www.linkedin.com/in/saudi-solarnova-861aba241",
  },
};

export const STATS = [
  { value: "40+", label: "Years of Heritage", labelAr: "عاماً من الخبرة" },
  { value: "6", label: "Product Lines", labelAr: "خطوط إنتاج" },
  { value: "100%", label: "In-House Manufacturing", labelAr: "تصنيع محلي" },
  { value: "5 Yr", label: "Industry Warranty", labelAr: "ضمان صناعي" },
];

export const GM_MESSAGE = {
  en: "Inspired by the new trajectory led by Saudi Arabia toward renewable energy, The Saudi Solar Factory was established to meet all the needs and demands of related projects. Through our experience we discovered how sensitive and important the batteries are to projects that we conduct, as all imported units would hardly match the required electricity specifications. We started manufacturing power storage units using Lithium-ion batteries and made significant contributions meeting our clients' demands. This went in parallel with other aspects of our industry — namely streetlights and solar panels.",
  ar: "استوحينا فكرة إنشاء مصنع للطاقة المتجددة ملهمين بالمسار الجديد الذي تقوده المملكة العربية السعودية نحو الطاقة المتجددة. يهدف المصنع السعودي للطاقة الشمسية لتلبية جميع احتياجات ومتطلبات المشاريع ذات الصلة. من خلال تجربتنا اكتشفنا مدى حساسية وأهمية بطاريات الكهرباء للمشاريع التي نقوم بها. بدأنا في تصنيع وحدات تخزين الطاقة باستخدام بطاريات ليثيوم أيون وقدمنا مساهمة كبيرة في تلبية طلبات عملائنا.",
  title: "General Manager",
  titleAr: "المدير العام",
};

export const OVERVIEW = {
  en: "Inspired by Saudi Arabia's bold trajectory toward renewable energy, SolarNova was established to meet the rigorous demands of modern, large-scale energy projects. Operating from our advanced manufacturing facility in Al-Kharj Industrial City, we are a premier manufacturer of custom-engineered power storage units, solar infrastructure, hybrid energy systems, and architecturally integrated photovoltaic solutions.",
  en2: "SolarNova is the Saudi arm of Global Solarnova, an internationally recognized solar technology company with roots tracing back to AEG's global solar technology division in Hamburg, Germany, in the early 1980s. Our engineers set up one of the first PV production lines ever, including specialized units for space flight and satellite technology.",
  ar: "استوحينا فكرة إنشاء مصنع للطاقة المتجددة ملهمين بالمسار الجديد الذي تقوده المملكة العربية السعودية نحو الطاقة المتجددة. انطلاقاً من مدينتنا الصناعية في الخرج، نُعد شركة رائدة في تصنيع وحدات تخزين الطاقة المصممة خصيصاً، والبنية التحتية للطاقة الشمسية، والأنظمة الهجينة، والحلول الكهروضوئية المدمجة معمارياً لتلبية كافة متطلبات المشاريع الضخمة والحديثة.",
};

export const VISION2030 = {
  en: "SolarNova is strategically positioned at the heart of Saudi Arabia's most transformative economic and environmental ambitions. The Kingdom has committed to generating 50% of its electricity from renewable sources by 2030, targeting 130 GW of total renewable capacity — with 58.7 GW from solar and 40 GW from wind.",
  stats: [
    { value: "50%", label: "Renewable Electricity by 2030" },
    { value: "130 GW", label: "Total Renewable Capacity Target" },
    { value: "48 GWh", label: "Battery Storage by 2030" },
    { value: "33 GW+", label: "In Development" },
  ],
  ar: "تقف سولارنوفا في قلب التحولات الاقتصادية والبيئية الأكثر طموحاً في المملكة. التزمت المملكة بتوليد 50% من كهربائها من مصادر متجددة بحلول 2030.",
};

export const HERITAGE = [
  {
    era: "1980s",
    milestone: "Established from AEG's solar division in Hamburg, Germany. Built one of the first PV production lines ever, including units for satellites and space flight.",
    milestoneAr: "تأسست من قسم الطاقة الشمسية في AEG بهامبورغ. بناء أول خطوط إنتاج الخلايا الشمسية.",
  },
  {
    era: "1990s",
    milestone: "Pioneered R&D for desert-resistant solar cells. Developed proprietary adhesives, glass formulations, and frame tolerances for extreme temperature cycling.",
    milestoneAr: "ريادة البحث والتطوير لخلايا شمسية مقاومة للبيئة الصحراوية.",
  },
  {
    era: "2016",
    milestone: "Established Saudi SolarNova (SGFS) — bringing German technology to Saudi industry with a fully localized manufacturing plant in Al-Kharj.",
    milestoneAr: "تأسيس سولارنوفا السعودية في مدينة الخرج الصناعية.",
  },
  {
    era: "2020s",
    milestone: "Scaled to serve Vision 2030 giga-projects. Expanded product lines to include ESS, transparent panels, and integrated streetlights. Projects include NEOM, Red Sea, Qiddiya.",
    milestoneAr: "التوسع لخدمة مشاريع رؤية 2030 العملاقة بما فيها نيوم والبحر الأحمر والقدية.",
  },
];

export const SERVICES = [
  {
    title: "Design Accuracy",
    titleAr: "دقة التصميم",
    description: "Our solutions are designed for specific utilization. Our clients decide their usage and we set the plan accordingly — residential, commercial, or industrial. Our engineers conduct site surveys, cost analysis, and creation of construction plans or assessment of existing structures.",
    descriptionAr: "نحن نؤمن أن لكل عميل طلب خاص. وعلى هذا الأساس يتم تصميم كل مشروع بشكل فردي. يقوم مهندسونا بإجراء مسح للموقع وتحليل التكلفة وإنشاء خطط بناء جديدة أو تقييم الهياكل القائمة.",
    icon: "ruler",
  },
  {
    title: "Meeting Client Expectations",
    titleAr: "تلبية توقعات عملائنا",
    description: "We thrive to assure our clients receive what they expected. We guarantee that our projects are developed to the best world standards. Our staff are well trained and experienced. Installation is carried out through the safest way possible.",
    descriptionAr: "نعمل جاهدين لحصول عملاؤنا على ما يتوقعونه من النظام الكهربائي. نحن نضمن أن يتم تطوير مشاريعنا وفقا لأفضل المعايير العالمية.",
    icon: "target",
  },
  {
    title: "Constant Follow Up",
    titleAr: "متابعة مستمرة",
    description: "Our contract for installation has no expire date. We constantly provide follow-up visits to ensure the system runs to its potential. Our engineers perform inspections and maintenance to verify full functionality for years to come.",
    descriptionAr: "عقد التركيب لا ينتهي بتاريخ الإنجاز. نحن نقدم باستمرار زيارات متابعة للتأكد من أن النظام يعمل بكامل إمكاناته.",
    icon: "refreshCcw",
  },
  {
    title: "Support & Maintenance",
    titleAr: "الدعم والصيانة",
    description: "We are a manufacturer for most of the materials utilized in the projects. This assures our customers having the best support and maintenance for years to come without interruption.",
    descriptionAr: "حيث نقوم بتصنيع معظم المواد المستخدمة في المشاريع التي نقوم بتنفيذها، فإن هذا يضمن لعملائنا الحصول على أفضل دعم وصيانة لسنوات قادمة دون انقطاع.",
    icon: "wrench",
  },
];

export const CORE_EDGE = [
  {
    title: "Desert-Optimized Engineering",
    titleAr: "هندسة محسّنة للبيئة الصحراوية",
    description: "While all imported energy storage units work in the environments they originated from and do not suit high temperatures, our energy engineers have gained sufficient experience to create projects that suit the desert environment of Saudi Arabia. We test each cell individually to ensure continuous operation under high temperatures.",
    descriptionAr: "في الوقت الذي تعمل به جميع وحدات تخزين الطاقة المستوردة في البيئة التي نشأت بها، ولا تناسب درجات الحرارة المرتفعة، فقد اكتسب مهندسو الطاقة لدينا الخبرة الكافية لإنشاء مشاريع تلائم البيئة الصحراوية.",
    icon: "thermometer",
  },
  {
    title: "No Room for Waiting",
    titleAr: "لا مجال للانتظار",
    description: "No hospital can operate without an Energy Storage Unit (UPS) — there is no room for waiting. The same applies to airports, military bases, and many vital installations. Our UPS systems provide uninterrupted power backup for critical infrastructure.",
    descriptionAr: "لا يمكن لأي مستشفى أن يعمل دون وحدة تخزين الطاقة (U.P.S)، حيث لا مجال للانتظار. ينطبق هذا بالطبع على المطارات والقواعد العسكرية والكثير من المنشآت الحيوية.",
    icon: "zap",
  },
  {
    title: "End-to-End Excellence",
    titleAr: "التميز من البداية للنهاية",
    description: "Because we manufacture most of the materials we utilize, we maintain total quality control throughout the entire value chain. Our comprehensive service model covers custom design, site surveying, safe installation, system commissioning, and continuous maintenance.",
    descriptionAr: "حيث أننا نقوم بتصنيع معظم المواد المستخدمة، فإننا نضمن أعلى مستويات الجودة.",
    icon: "workflow",
  },
  {
    title: "German Technology, Saudi Industry",
    titleAr: "تكنولوجيا ألمانية، صناعة سعودية",
    description: "We are not simply a distributor repackaging foreign products. SolarNova is a true manufacturer — a Saudi partner of a powerful global provider. The experience and quality of 'Made in Germany' are now within reach of 'Made in Saudi Arabia.'",
    descriptionAr: "لسنا مجرد موزع لمنتجات أجنبية. سولارنوفا مُصنّع حقيقي.",
    icon: "globe",
  },
];

export const PRODUCTS = [
  {
    id: "lithium",
    title: "Lithium-Ion Batteries & ESS",
    titleAr: "بطاريات الليثيوم وأنظمة تخزين الطاقة",
    description: "Through our unique experience in building solar units, we discovered that the batteries are the most important component. This drove our team to expand and concentrate on building Energy Storage Systems. We provide warranties that outperform all global competitors.",
    descriptionAr: "نتميز بتصنيع بطاريات الليثيوم التي تعتبر المكون الأهم في وحدات الإنارة الشمسية، يتم استخدام البطاريات في جميع المجالات المدنية والعسكرية ونقوم بتقديم ضمان على الأداء يتفوق على جميع المنافسين العالميين. بفضل خبرتنا في هذا المجال ننفرد بتقديم الدعم السريع والاستبدال الفوري.",
    image: "https://images.unsplash.com/photo-1674606071893-2a9023075f70?w=800&q=80",
  },
  {
    id: "streetlights",
    title: "Integrated Solar Streetlights",
    titleAr: "وحدات إنارة الشوارع المدمجة",
    description: "Our huge line of products provides a variety of choices. We are the only manufacturer providing five years warranty on all products. Our engineers made excellent additions to tolerate extreme desert temperatures, and we added longer-life batteries for extended working hours. No need to dig streets or extend cables anymore.",
    descriptionAr: "لا حاجة لحفر الشوارع وتمديد كيبلات كهربائية بعد اليوم. نوفر للجميع وحدات إنارة تعمل بالطاقة الشمسية وتقوم بتخزين الطاقة ضمن أفضل أنواع البطاريات التي يتم تصنيعها في مصنعنا. تجهيز الشوارع ومواقف السيارات والحدائق أصبح أسهل بفضل توفر جميع المقاسات العملية.",
    image: "https://images.unsplash.com/photo-1587207433786-83087c4090e5?w=800&q=80",
  },
  {
    id: "transparent",
    title: "Transparent Solar Panels",
    titleAr: "ألواح الطاقة الشمسية الشفافة",
    description: "We are the only factory in the Middle East fully equipped to manufacture transparent panels that work well for building facades. All sizes and colours are available, giving architects immense creative freedom for windows, skylights, and mall rooftops.",
    descriptionAr: "نتميز بكوننا المصنع الوحيد في الشرق الأوسط المهيأ لإنتاج ألواح شمسية شفافة. يسمح ذلك باستخدام الألواح في واجهات البناء والنوافذ وأسقف الأسواق المركزية والمحطات. توفر جميع الألوان والمقاسات يعطي المهندس المعماري مساحة كبيرة للإبداع.",
    image: "https://images.unsplash.com/photo-1743352476730-056502fba10b?w=800&q=80",
  },
  {
    id: "ups",
    title: "UPS — Uninterrupted Power Supply",
    titleAr: "وحدات الطاقة غير المنقطعة",
    description: "Our expert engineers design the best High-Capacity Lithium Battery power backup systems. The modular design is flexible to meet variable demands — critical for hospitals, airports, military bases, data centers, and vital infrastructure where there is no room for power interruption.",
    descriptionAr: "يقوم مهندسونا بتصميم أفضل أنظمة النسخ الاحتياطي للطاقة بسعة عالية من بطاريات الليثيوم. التصميم المعياري مرن لتلبية الطلبات المتنوعة.",
    image: "https://images.unsplash.com/photo-1502637098811-fa9526d2b659?w=800&q=80",
  },
  {
    id: "hybrid",
    title: "Hybrid Solar Systems",
    titleAr: "الأنظمة الهجينة للطاقة الشمسية",
    description: "Hybrid solar systems combine the best from grid-tied and off-grid solar systems. These can be described as off-grid solar with utility backup power, or grid-tied solar with battery storage — providing 24/7 energy availability for any environment.",
    descriptionAr: "أنظمة متكاملة تجمع بين الطاقة الشمسية وطاقة الرياح وتخزين البطاريات لتوفير الطاقة على مدار الساعة.",
    image: "https://images.unsplash.com/photo-1595437193398-f24279553f4f?w=800&q=80",
  },
  {
    id: "bipv",
    title: "Building-Integrated Photovoltaics",
    titleAr: "الخلايا الكهروضوئية المدمجة معمارياً",
    description: "Architecturally integrated solar cells that replace conventional building materials. Facades, canopies, and cladding that generate power while enhancing building aesthetics — designed for smart city developments and landmark projects.",
    descriptionAr: "خلايا شمسية مدمجة معمارياً تحل محل مواد البناء التقليدية.",
    image: "https://images.unsplash.com/photo-1726795867801-63c0a37b80c6?w=800&q=80",
  },
];

export const PROJECTS = [
  { name: "NEOM Project", nameAr: "توريد وحدات إنارة لمشروع نيوم", desc: "Supplier for NEOM project" },
  { name: "The Red Sea Project", nameAr: "توريد وحدات إنارة لمشروع البحر الأحمر", desc: "Supplier for Red Sea project" },
  { name: "Al-Qiddiya Administrative Office", nameAr: "مشروع الطاقة المتجددة - المكتب الاستشاري - القدية", desc: "Renewable energy — Al-Qiddiya administrative office" },
  { name: "Riyadh Season", nameAr: "مشروع إنارة مواقف السيارات - موسم الرياض", desc: "Car park light projects for Riyadh Season" },
  { name: "Arab National Bank", nameAr: "مشروع البنك الوطني للطاقة المتجددة", desc: "Arab National Bank renewable energy project" },
  { name: "Saudi Yemen Development Program", nameAr: "مشروع إنارة شوارع مدينتي مأرب وعدن تحت إشراف البرنامج السعودي لتنمية وإعمار اليمن", desc: "Ma'rib & Aden street lighting — Saudi Program for Yemen" },
];

export const SECTORS = [
  { name: "Healthcare & Hospitals", nameAr: "الرعاية الصحية والمستشفيات", desc: "Uninterruptible power for life-critical systems", icon: "heartPulse" },
  { name: "Military & Defense", nameAr: "الجيش والدفاع", desc: "Ruggedized energy solutions for bases and field operations", icon: "shield" },
  { name: "Aviation & Airports", nameAr: "الطيران والمطارات", desc: "Continuous backup power and perimeter lighting", icon: "plane" },
  { name: "Banking & Financial", nameAr: "البنوك والمالية", desc: "Data center and branch power resilience", icon: "landmark" },
  { name: "Giga-Projects & Smart Cities", nameAr: "المشاريع العملاقة والمدن الذكية", desc: "NEOM, Red Sea, Qiddiya, and beyond", icon: "building2" },
  { name: "Entertainment & Tourism", nameAr: "الترفيه والسياحة", desc: "Event-scale lighting and temporary power", icon: "sparkles" },
  { name: "Municipal Infrastructure", nameAr: "البنية التحتية البلدية", desc: "Streets, parks, public spaces, and parking", icon: "treePine" },
  { name: "International Development", nameAr: "التنمية الدولية", desc: "Aid-funded infrastructure in conflict zones", icon: "handshake" },
];

export const WHY_SOLARNOVA = [
  {
    title: "40+ Years of Solar Heritage",
    description: "From AEG's labs in Hamburg to Al-Kharj — decades of unbroken PV innovation.",
  },
  {
    title: "Only MENA Transparent Panel Maker",
    description: "Exclusive regional capability in architecturally integrated transparent PV.",
  },
  {
    title: "True Manufacturer, Not Reseller",
    description: "In-house production of most materials ensures quality control and supply chain security.",
  },
  {
    title: "Desert-Proven Engineering",
    description: "Proprietary R&D for extreme heat, sand, and thermal cycling unique to Arabia.",
  },
  {
    title: "Giga-Project Track Record",
    description: "Proven execution on NEOM, Red Sea, Qiddiya, Riyadh Season, and international programs.",
  },
  {
    title: "End-to-End Service Model",
    description: "Design, survey, install, commission, and maintain — a single point of accountability.",
  },
];

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "Services", href: "#services" },
  { label: "Products", href: "#products" },
  { label: "Projects", href: "#projects" },
  { label: "Contact", href: "#contact" },
];

export const FACTORY_IMAGES = [
  "https://customer-assets.emergentagent.com/job_a3f0e1fc-5dfc-46b5-99fb-a21eb6f14539/artifacts/77n9nuq9_WhatsApp%20Image%202026-02-14%20at%209.02.11%20PM%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_a3f0e1fc-5dfc-46b5-99fb-a21eb6f14539/artifacts/r6y5uml1_WhatsApp%20Image%202026-02-14%20at%209.02.13%20PM%20%281%29.jpeg",
  "https://customer-assets.emergentagent.com/job_a3f0e1fc-5dfc-46b5-99fb-a21eb6f14539/artifacts/rmlgyxqh_WhatsApp%20Image%202026-02-14%20at%209.02.13%20PM%20%282%29.jpeg",
  "https://customer-assets.emergentagent.com/job_a3f0e1fc-5dfc-46b5-99fb-a21eb6f14539/artifacts/8oual3uq_WhatsApp%20Image%202026-02-14%20at%209.02.14%20PM.jpeg",
];

export const FACTORY_VIDEO = "https://customer-assets.emergentagent.com/job_a3f0e1fc-5dfc-46b5-99fb-a21eb6f14539/artifacts/7ver4af9_WhatsApp%20Video%202026-02-14%20at%209.02.12%20PM.mp4";
